import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default function index(){
  const mainPic = document.querySelector('section.main')
  if(mainPic){
    mainPic.classList.add('active')
  }
}
